import { Component } from '@angular/core';

// Fusszeile der öffentlichen Seiten: Impressum · Datenschutzerklärung · Nutzungsbedingungen und Copyright
@Component({
  standalone: false,
  selector: 'app-auth-footer',
  template: `
    <footer class="ac-footer">
      <nav class="ac-footer__links" [attr.aria-label]="'legalPages.footerNav' | translate">
        <a routerLink="/imprint">{{ "legalPages.imprint" | translate }}</a>
        <span aria-hidden="true">·</span>
        <a routerLink="/privacy">{{ "legalPages.privacy" | translate }}</a>
        <span aria-hidden="true">·</span>
        <a routerLink="/terms">{{ "legalPages.terms" | translate }}</a>
      </nav>
      <div>{{ "acceptPage.footer" | translate: { year: currentYear } }}</div>
    </footer>
  `,
  styleUrls: ['./auth-footer.component.scss']
})
export class AuthFooterComponent {
  readonly currentYear = new Date().getFullYear();
}
